import classNames from 'classnames';
import type React from 'react';
import { Link } from 'react-router-dom';

import { IconZing } from 'src/components/icons/icon-zing/icon-zing';
import {
  GACalculatorDimensionName,
  GACalculatorEvent,
  GAHeaderDimensionName,
  GAHeaderEvent,
  Route,
} from 'src/constants';
import { sendGAEvent } from 'src/services/analytics/ga';

interface LogoProps {
  isCalculatorRoute: boolean;
}

export const Logo: React.FC<LogoProps> = ({ isCalculatorRoute }) => {
  const onClick = () => {
    sendGAEvent(isCalculatorRoute ? GACalculatorEvent.CALCULATOR_CLICKS : GAHeaderEvent.HEADER_CLICKS, {
      [isCalculatorRoute ? GACalculatorDimensionName.CALCULATOR : GAHeaderDimensionName.HEADER]: 'logo_click',
    });
  };

  return (
    <>
      <Link
        to={Route.OVERVIEW}
        target={isCalculatorRoute ? '_blank' : undefined}
        className={classNames('flex items-center gap-x-6', { 'max-lg:hidden': isCalculatorRoute })}
        onClick={onClick}
      >
        <img src="/assets/public/images/zing-logo.webp" alt="logo" width={30} height={28} />
        <IconZing />
      </Link>

      {isCalculatorRoute && (
        <div role="button" tabIndex={0} onClick={onClick} className="flex items-center gap-x-6 lg:hidden">
          <img src="/assets/public/images/zing-logo.webp" alt="logo" width={30} height={28} />
          <IconZing />
        </div>
      )}
    </>
  );
};
